module.exports = __webpack_public_path__ + "img/benefit-09-chain-1.2b077b96.png";